export default __webpack_public_path__ + "static/media/ev-charging.2af72ce7.svg";